<template>
  <div class="top-bar bg-secondary smooth-shadow">
    <div class="container">
      <div class="top-bar-contents">
        <div class="search-bar flex-row-align-center">
          <i class="material-icons">search</i>
          <input
            class="ghost-input fc mar-left-10"
            placeholder="what are you looking for?"
          />
        </div>
        <TopBarMenu />
      </div>
    </div>
  </div>
</template>

<script>
import TopBarMenu from "@/components/home/views/TopBarMenu";
import { mapGetters } from "vuex";

export default {
  components: {
    TopBarMenu,
  },
  computed: {
    ...mapGetters("Route", ["getChild"]),
  },
};
</script>

<style lang="scss">
.top-bar-contents {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 66px;

  .search-bar {
    .custom-input {
      border: 0;
    }
  }
  .brand-logo {
    padding-left: 15px;
    padding-right: 15px;
    font-size: 1.2em;
  }
  .navigation-menu {
    list-style-type: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    height: 100%;
    margin: 0;
    padding: 0;

    a {
      text-decoration: none;
      color: var(--font-color);
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 20px 0 15px;
      border-bottom: 2px solid var(--color-transparent);
      transition: 0.2s all ease-in-out;

      &.set-active {
        color: var(--color-primary);
        border-bottom: 2px solid var(--color-primary);
      }

      li {
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
